import React from 'react';
import Image from 'next/image';
import { Translate } from '~/i18n';
import Modal from '~/components/common/modal';
import { Section } from '../common/section';
import { Button } from '../common/button';

const VatSamplePreviewModal = ({ open, setOpen }: any) => {
   return (
      <Modal size={800} open={open}>
         <Modal.Body>
            <Section className="px-4 pb-5 rounded-2xl">
               <div className="relative w-full h-[700px] ">
                  <Image
                     layout="fill"
                     src="/images/profile/vat-exemption-cert-sample.png"
                     alt="image"
                     quality={100}
                     objectFit="contain"
                     className=""
                  />
               </div>
               <div className="flex justify-end mt-6 ">
                  <Button
                     onClick={() => setOpen(false)}
                     theme="outline-primary"
                     className="h-10 !w-32">
                     <Translate id="common:close" />
                  </Button>
               </div>
            </Section>
         </Modal.Body>
      </Modal>
   );
};

export default VatSamplePreviewModal;
